import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Transaction} from '~local/app/types/Transaction';
import {Observable} from 'rxjs';
import {DataSourceResponse, DataSourceService} from './DataSourceService';
import {UserRoleCode} from '~shared/types/user.types';

@Injectable()
export class TransactionsService extends DataSourceService<Transaction> {
    public explorerLinks: { [key: string]: string } = null;

    constructor(private http: HttpClient) {
        super();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10,
        globalFilter: string = null
    ): Observable<DataSourceResponse<Transaction>> {
        return this.http.get<DataSourceResponse<Transaction>>(
            '/admin/transactions/list/' + (globalFilter != null ? globalFilter : ''),
            {
                params: new HttpParams()
                    .set('filter', filter)
                    .set('orderBy', orderBy)
                    .set('sort', orderDirection.toUpperCase())
                    .set('skip', pageNumber.toString())
                    .set('take', pageSize.toString())
            }
        );
    }

    public getTransactions(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10
    ): Observable<DataSourceResponse<Transaction>> {
        return this.http.get<DataSourceResponse<Transaction>>('/admin/transactions/list', {
            params: new HttpParams()
                .set('filter', filter)
                .set('orderBy', orderBy)
                .set('sort', orderDirection.toUpperCase())
                .set('skip', pageNumber.toString())
                .set('take', pageSize.toString())
        });
    }

    public getTransaction(id: number | string): Observable<Transaction> {
        return this.http.get<Transaction>('/admin/transactions/' + id);
    }

    public postConfirmTransaction(id: number | number[], amount: number = null): Observable<Transaction> {
        return this.http.post<any>('/admin/transactions/action/confirm', { id, amount });
    }

    public postCancelTransaction(id: number | number[]): Observable<Transaction> {
        return this.http.post<any>('/admin/transactions/action/cancel', { id });
    }

    public loadExplorerLinks() {
        this.http.get<any>('/admin/transactions/explorers').subscribe((data) => {
            this.explorerLinks = data;
        });
    }

    public getTransactionReport(type: string, transactionType?: string, filter: string = '', orderBy: string = '', orderDirection: string = 'ASC') {
        const params = new HttpParams()
          .set('filter', filter)
          .set('orderBy', orderBy)
          .set('sort', orderDirection.toUpperCase())
        if (transactionType) {
            return this.http.get(`/admin/transactions/reports/${type}/${transactionType}`, { responseType: 'blob', params });
        }

        return this.http.get(`/admin/transactions/reports/${type}`, { responseType: 'blob', params });
    }

    public getRiskScoreInfoByAddress(address: string): Observable<any> {
        return this.http.get<any>(`/admin/transactions/riskscore/address/${address}`);
    }

    public getRiskScoreInfoByTransaction(tx: string): Observable<any> {
        return this.http.get<any>(`/admin/transactions/riskscore/transaction/${tx}`);
    }

    public custodyTransactionAction(formData: { action: string; id: number; reason?: string }): Observable<any> {
        return this.http.post<any>('/admin/custody/action', formData);
    }

    public approveTransaction($transactionId: string | number, $roleCode: UserRoleCode): Observable<any> {
      return this.http
        .put(`/admin/transactions/${$transactionId}/approve`, {
          roleCode: $roleCode,
        });
    }

  public rejectTransaction($transactionId: string | number, $roleCode: UserRoleCode): Observable<any> {
    return this.http
      .put(`/admin/transactions/${$transactionId}/reject`, {
        roleCode: $roleCode,
      });
  }
}
